import { useState } from "react";
import { useGetAssignmentMarksQuery } from "../../../features/assignmentMark/assignmentMarkApi";
import EmptyResult from "../../ui/EmptyResult";
import Error from "../../ui/Error";
import Loading from "../../ui/Loading";
import MessageToast from "../../ui/MessageToast";
import Table from "../../ui/Table";
import AssignmentMarkItem from "./AssignmentMarkItem";

export default function AssignmentMarks() {
	const {
		data: assignmentMarks,
		isLoading,
		isError,
	} = useGetAssignmentMarksQuery() || {};

	const [assignmentMarkSentResult, setAssignmentMarkSentResult] =
		useState("");

	// Decide what to render
	let content = null;
	if (isLoading) {
		content = <Loading />;
	} else if (!isLoading && isError) {
		content = <Error message="There was an error!" />;
	} else if (!isLoading && !isError && assignmentMarks?.length === 0) {
		content = <EmptyResult message="No quizzes found, please add" />;
	} else if (!isLoading && !isError && assignmentMarks?.length > 0) {
		let headers = [
			"Assignment",
			"Date",
			"Student Name",
			"Repo Link",
			"Mark",
		];

		const totalSubmittedAssignmentsCount = assignmentMarks.length;
		const totalPending = assignmentMarks.reduce((prev, curr) => {
			if (curr.status === "pending") {
				return prev + 1;
			}
			return prev;
		}, 0);
		const totalMarkSentCount =
			totalSubmittedAssignmentsCount - totalPending;

		content = (
			<div className="px-3 py-20 bg-opacity-10">
				<ul className="assignment-status">
					<li>
						Total <span>{totalSubmittedAssignmentsCount}</span>
					</li>
					<li>
						Pending <span>{totalPending}</span>
					</li>
					<li>
						Mark Sent <span>{totalMarkSentCount}</span>
					</li>
				</ul>
				<div className="overflow-x-auto mt-4">
					<Table headers={headers}>
						{assignmentMarks.map((assMark) => (
							<AssignmentMarkItem
								key={assMark.id}
								assignmentMark={assMark}
								markSendResultHandler={
									setAssignmentMarkSentResult
								}
							/>
						))}
					</Table>
				</div>
			</div>
		);
	}

	return (
		<section className="py-6 bg-primary">
			<div className="mx-auto max-w-full px-5 lg:px-20">{content}</div>
			{assignmentMarkSentResult === "sent-success" && (
				<MessageToast message="Assignment mark sent success" />
			)}
			{assignmentMarkSentResult === "sent-fail" && (
				<MessageToast
					message="Assignment mark sent failed!"
					type="error"
					delay={3000}
				/>
			)}
		</section>
	);
}
